import { Component, Input } from '@angular/core';
import { Priority, Sla } from '@data/models/sla-period.model';

@Component({

    selector: 'syn-project-wizard-sla-gti-gtr-read',
    templateUrl: 'project-wizard-sla-gti-gtr-read.component.html',
    styleUrls: ['project-wizard-sla-gti-gtr-read.component.scss']
})
export class ProjectWizardSlaGtiGtrReadComponent {

    @Input({ required: true }) sla: Sla;

    public getPriorityLabel(): string {
        switch (this.sla.priority) {
            case Priority.URGENT: return 'P1';
            case Priority.HIGH: return 'P2';
            case Priority.NORMAL: return 'P3';
            case Priority.LOW: return 'P4';
            default: return 'Inconnu';
        }
    }
}
